import { render, staticRenderFns } from "./RelatorioAvariaProdutosFilialPorData.vue?vue&type=template&id=73c4092d&scoped=true"
import script from "./RelatorioAvariaProdutosFilialPorData.vue?vue&type=script&lang=js"
export * from "./RelatorioAvariaProdutosFilialPorData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c4092d",
  null
  
)

export default component.exports